(() => {
  if (customElements.get('article-signup-bar')) return;
  customElements.define('article-signup-bar', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.hidden = false;
      const target = () => document.querySelector('[data-article-newsletter="inline"]');
      const onScreen = (el) => {
        const r = el.getBoundingClientRect();
        return r.top < innerHeight && r.bottom > 0;
      };
      this.sync = () => {
        this.frame = null;
        const card = target();
        const footer = document.querySelector('footer .foot');
        // Done once the inline form shows its success message (errors stay retryable).
        const done = document.documentElement.classList.contains('is-subscribed')
          || !!card?.querySelector('[data-signup-msg]:not([hidden]):not(.signup__msg--error)');
        const busy = !!card?.contains(document.activeElement);
        const visible = !!card && !done && !busy && innerWidth < 1100
          && scrollY > innerHeight * .5 && !onScreen(card) && !(footer && onScreen(footer));
        this.toggleAttribute('data-visible', visible);
        this.inert = !visible;
      };
      const queue = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.sync);
      };
      this.querySelector('[data-article-signup-jump]')?.addEventListener('click', () => {
        const input = target()?.querySelector('input[type="email"]');
        if (!input) return;
        const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches && !document.documentElement.classList.contains('lp-rm');
        input.scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
        input.focus({ preventScroll: true });
        queue();
      }, { signal });
      window.addEventListener('scroll', queue, { passive: true, signal });
      window.addEventListener('resize', queue, { signal });
      document.addEventListener('focusin', queue, { signal });
      document.addEventListener('submit', () => setTimeout(queue, 1500), { signal });
      document.addEventListener('shopify:section:load', queue, { signal });
      document.addEventListener('shopify:section:unload', queue, { signal });
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
})();
